import React from 'react';

const TextHero = ({ header, subheader }) => (
    <section className="text-hero-section">
        <div className="container py-5">
            <div className="row">
                <div className="col-12 text-center py-5">
                    <h1 className="m-0">{header}</h1>
                    <p className="text-xl mt-4">{subheader}</p>
                </div>
            </div>
        </div>
    </section>
);

export default TextHero;
